import "./Modal.scss";
import "./EditBoatModal.scss";
import { useEffect } from "react";

function EditBoatModal({
  editModal,
  editForm,
  editTab,
  editImages,
  allTimeSlots,
  allSummerTimeSlots,
  setEditTab,
  setEditImages,
  handleEditFormChange,
  handlePricingChange,
  handleSummerPricingChange,
  onClose,
  onSaveEdit,
}) {
  useEffect(() => {
    if (editModal) {
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = "";
      };
    }
  }, [editModal]);

  if (!editModal || !editForm) return null;

  return (
    <div
      className="popup-overlay-admin"
      onClick={(e) =>
        e.target.classList.contains("popup-overlay-admin") && onClose()
      }
    >
      <div className="popup-content large">
        <button className="close-button" onClick={onClose}>
          &times;
        </button>
        <h1>Edit {editModal.name}</h1>

        <div className="modal-tabs">
          <button
            className={editTab === "info" ? "active" : ""}
            onClick={() => setEditTab("info")}
          >
            Info
          </button>
          <button
            className={editTab === "pricing" ? "active" : ""}
            onClick={() => setEditTab("pricing")}
          >
            Pricing
          </button>
        </div>

        {editTab === "info" && (
          <div className="edit-info">
            <label>
              Name
              <input
                name="name"
                value={editForm.name}
                onChange={handleEditFormChange}
              />
            </label>
            <label>
              Type
              <input
                name="type"
                value={editForm.type}
                onChange={handleEditFormChange}
              />
            </label>
            <label>
              Capacity
              <input
                type="number"
                name="capacity"
                value={editForm.capacity}
                onChange={handleEditFormChange}
              />
            </label>
            <label>
              Replace Images
              <small>Uploading new images will replace all existing ones</small>
              <input
                type="file"
                multiple
                accept="image/*"
                onChange={(e) => setEditImages(Array.from(e.target.files))}
              />
              {editImages.length > 0 && (
                <span className="file-count">
                  {editImages.length} file(s) selected
                </span>
              )}
            </label>
          </div>
        )}

        {editTab === "pricing" && (
          <div className="pricing-form">
            {editModal &&
            editModal.destinations &&
            editModal.destinations.length > 0 ? (
              <>
                {/* Normal Season Pricing */}
                <div className="pricing-section-container">
                  <h2>Normal Season Pricing (3 Slots)</h2>
                  {editModal.destinations.map((dest) => {
                    const destName = dest.name
                      ? dest.name.toLowerCase()
                      : dest.toLowerCase();
                    const isSlotBased =
                      dest.isSlotBased !== undefined ? dest.isSlotBased : true;

                    return (
                      <div
                        className="pricing-section"
                        key={`normal-${destName}`}
                      >
                        <h3>
                          {destName.charAt(0).toUpperCase() + destName.slice(1)}
                        </h3>
                        <div className="pricing-grid">
                          {isSlotBased ? (
                            <>
                              {allTimeSlots &&
                                allTimeSlots.map((slot, idx) => (
                                  <label
                                    key={`${destName}-slot${idx + 1}`}
                                  >
                                    {slot.label || `Slot ${idx + 1}`}
                                    <input
                                      type="number"
                                      min="0"
                                      value={
                                        editForm.pricing[destName]?.[
                                          `slot${idx + 1}`
                                        ] || 0
                                      }
                                      onChange={(e) =>
                                        handlePricingChange(
                                          destName,
                                          `slot${idx + 1}`,
                                          e.target.value
                                        )
                                      }
                                    />
                                  </label>
                                ))}
                              <label>
                                Full Day Bundle
                                <input
                                  type="number"
                                  min="0"
                                  value={
                                    editForm.pricing[destName]?.fullDay || 0
                                  }
                                  onChange={(e) =>
                                    handlePricingChange(
                                      destName,
                                      "fullDay",
                                      e.target.value
                                    )
                                  }
                                />
                              </label>
                              {allTimeSlots &&
                                allTimeSlots.length >= 2 && (
                                  <label>
                                    2-Slot Bundle (adjacent slots)
                                    <input
                                      type="number"
                                      min="0"
                                      value={
                                        editForm.pricing[destName]?.twoSlot || 0
                                      }
                                      onChange={(e) =>
                                        handlePricingChange(
                                          destName,
                                          "twoSlot",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </label>
                                )}
                            </>
                          ) : (
                            <>
                              <label>
                                Full Trip
                                <input
                                  type="number"
                                  min="0"
                                  value={
                                    editForm.pricing[destName]?.full || 0
                                  }
                                  onChange={(e) =>
                                    handlePricingChange(
                                      destName,
                                      "full",
                                      e.target.value
                                    )
                                  }
                                />
                              </label>
                              <label>
                                Drop-off Only
                                <input
                                  type="number"
                                  min="0"
                                  value={
                                    editForm.pricing[destName]?.dropOff || 0
                                  }
                                  onChange={(e) =>
                                    handlePricingChange(
                                      destName,
                                      "dropOff",
                                      e.target.value
                                    )
                                  }
                                />
                              </label>
                            </>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>

                {/* Summer Season Pricing */}
                <div className="pricing-section-container summer-pricing">
                  <h2>Summer Season Pricing (2 Slots)</h2>
                  {editModal.destinations.map((dest) => {
                    const destName = dest.name
                      ? dest.name.toLowerCase()
                      : dest.toLowerCase();
                    const isSlotBased =
                      dest.isSlotBased !== undefined ? dest.isSlotBased : true;

                    return (
                      <div
                        className="pricing-section"
                        key={`summer-${destName}`}
                      >
                        <h3>
                          {destName.charAt(0).toUpperCase() + destName.slice(1)}
                        </h3>
                        <div className="pricing-grid">
                          {isSlotBased ? (
                            <>
                              {/* Slot 1 */}
                              <label>
                                {allSummerTimeSlots?.[0]?.label || "Slot 1"}
                                <input
                                  type="number"
                                  min="0"
                                  value={
                                    editForm.summerPricing[destName]?.slot1 || 0
                                  }
                                  onChange={(e) =>
                                    handleSummerPricingChange(
                                      destName,
                                      "slot1",
                                      e.target.value
                                    )
                                  }
                                />
                              </label>
                              {/* Slot 2 */}
                              <label>
                                {allSummerTimeSlots?.[1]?.label || "Slot 2"}
                                <input
                                  type="number"
                                  min="0"
                                  value={
                                    editForm.summerPricing[destName]?.slot2 || 0
                                  }
                                  onChange={(e) =>
                                    handleSummerPricingChange(
                                      destName,
                                      "slot2",
                                      e.target.value
                                    )
                                  }
                                />
                              </label>
                              {/* Full Day (when both slots selected) */}
                              <label>
                                Full Day (Both Slots)
                                <input
                                  type="number"
                                  min="0"
                                  value={
                                    editForm.summerPricing[destName]?.fullDay || 0
                                  }
                                  onChange={(e) =>
                                    handleSummerPricingChange(
                                      destName,
                                      "fullDay",
                                      e.target.value
                                    )
                                  }
                                />
                              </label>
                            </>
                          ) : (
                            <>
                              <label>
                                Full Trip
                                <input
                                  type="number"
                                  min="0"
                                  value={
                                    editForm.summerPricing[destName]?.full || 0
                                  }
                                  onChange={(e) =>
                                    handleSummerPricingChange(
                                      destName,
                                      "full",
                                      e.target.value
                                    )
                                  }
                                />
                              </label>
                              <label>
                                Drop-off Only
                                <input
                                  type="number"
                                  min="0"
                                  value={
                                    editForm.summerPricing[destName]?.dropOff || 0
                                  }
                                  onChange={(e) =>
                                    handleSummerPricingChange(
                                      destName,
                                      "dropOff",
                                      e.target.value
                                    )
                                  }
                                />
                              </label>
                            </>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </>
            ) : (
              <p className="no-destinations-msg">
                No destinations assigned to this boat yet. Assign destinations in
                the Destinations tab first.
              </p>
            )}
          </div>
        )}

        <div className="modal-footer">
          <button className="cancel-btn" onClick={onClose}>
            Cancel
          </button>
          <button className="save-btn" onClick={onSaveEdit}>
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
}

export default EditBoatModal;
